export const MenuOptionLists = {
  hospital: {
    main:
      [
        'dashboard',
        'advancedToolStats',
        'importDicom',
        'studies',
        'patients',
        'cases',
        'virtualVisits',
        'protocols',
        'groups',
        'files',
        'settings',
      ],
    settings: [
      'general',
      'menu',
      'team',
      'group',
      'patients',
      'openStowRs',
      'remotePacs',
      'back',
    ],
  },
  patient: {
    main: [
      'dashboard',
      'cases',
      'virtualVisits',
      'studies',
    ],
  },
  provider: {
    main: [
      'advancedTools',
    ],
  },
  user: {
    doctor: [
      'profile',
      'plan',
      'back',
    ],
    patient: [
      'profile',
      'back',
    ],
  },
};
